import { Button, Dropdown, Menu } from 'antd';
import React from 'react';
import { Down } from 'patternx-svg';

interface IStateUploadBtn {
  menuClick: (key: any) => void;
  btnRender?: React.ReactNode;
}
export default React.memo((props: IStateUploadBtn) => {
  return (
    <Dropdown
      overlay={
        <Menu onClick={props.menuClick}>
          <Menu.Item key="file">上传文件</Menu.Item>
          <Menu.Item key="directory">上传文件夹</Menu.Item>
        </Menu>
      }
      placement="bottom"
    >
      {props.btnRender ? (
        props.btnRender
      ) : (
        <Button className="flex-jc-ai-center" type="primary">
          <span>上传</span>
          <Down width={16} height={16} />
        </Button>
      )}
    </Dropdown>
  );
});
